// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCtXSUDjTO7y1Y7Jco4GMHFD6JqHqAtHMc',
    authDomain: 'shoppinglist-b0e53.firebaseapp.com',
    projectId: 'shoppinglist-b0e53',
    storageBucket: 'shoppinglist-b0e53.appspot.com',
    messagingSenderId: '604045437141',
    appId: '1:604045437141:web:20f851d237a082fc3dda5c'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
